import { TextEntryPoint } from "src/types/textEntryPoints";
import { ApiWebchatEntryPoints } from ".";
import { BaseService } from "../baseService";
import { AxiosResponse } from "axios";
import {
	Controllers,
	GeneralRoutes,
	MessagingEntryPointApiRoutes,
	WebchatMediaApiRoutes,
} from "src/utils/constants";
import { HttpMethods } from "../httpMethods";

export class WebchatEntryPointService
	extends BaseService
	implements ApiWebchatEntryPoints
{
	async createWebchatEntryPoint(
		entryPoint: TextEntryPoint
	): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Post,
			Controllers.WebchatEntryPoint,
			GeneralRoutes.Create,
			null,
			entryPoint
		);
	}

	async getAllWebchatEntryPoints(): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.WebchatEntryPoint,
			MessagingEntryPointApiRoutes.AllEntryPoints
		);
	}

	async getWebchatEntryPointById(
		entryPointId: string
	): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Get,
			Controllers.WebchatEntryPoint,
			"",
			`${entryPointId}`
		);
	}

	async updateWebchatEntryPoint(
		entryPoint: TextEntryPoint
	): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Post,
			Controllers.WebchatEntryPoint,
			GeneralRoutes.Update,
			null,
			entryPoint
		);
	}

	async uploadLogoToStorage(formData: FormData): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Post,
			Controllers.WebchatMedia,
			WebchatMediaApiRoutes.UploadLogoToStorage,
			null,
			formData
		);
	}

	async deleteLogoFromStorage(fileName: string): Promise<AxiosResponse> {
		return this.invokeServiceCall(
			HttpMethods.Post,
			Controllers.WebchatMedia,
			WebchatMediaApiRoutes.DeleteLogoFromStorage,
			null, 
			fileName
		);
	}
}
